export enum ValuationReportModeEnum {
  SALE = "sale",
  LETTING = "letting"
}
